import { i18n } from '@lingui/core';

export const defaultLocale = 'en';
export const supportedUILocales = ['en', 'cs', 'sk'];

export type SupportedUILocale = (typeof supportedUILocales)[number];

let detectedLocale = defaultLocale;

export function getCurrentLocale() {
  return detectedLocale;
}

export function detectBrowserLocale() {
  const languages = [...(navigator.languages ?? []), navigator.language];

  return (
    languages
      .filter(Boolean)
      .map(language => language.toLowerCase().split('-')[0])
      .find(locale => supportedUILocales.includes(locale)) ?? defaultLocale
  );
}

export async function dynamicActivate() {
  detectedLocale = detectBrowserLocale();

  try {
    // Try to load the locale
    const { messages } = await import(`./locales/${detectedLocale}.po`);

    i18n.load(detectedLocale, messages);
    i18n.activate(detectedLocale);
  } catch (error) {
    console.error(`Failed to load locale: ${detectedLocale}`, error);

    // Fallback to default locale if not already trying to load it
    if (detectedLocale !== defaultLocale) {
      const { messages } = await import(`./locales/${defaultLocale}.po`);

      i18n.load(defaultLocale, messages);
      i18n.activate(defaultLocale);
      detectedLocale = defaultLocale;
    }
  }

  document.documentElement.lang = detectedLocale;
}
